// extracted by mini-css-extract-plugin
module.exports = {"root":"SketchNavigation_root__1QluO","hidden":"SketchNavigation_hidden__1qvRt","visible":"SketchNavigation_visible__3yHq2","sub":"SketchNavigation_sub__N3frk"};